module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAACgAAAAAYsJrPAAAAn0lEQVQYGYVQSwpCMQycaT2DCOIt3ApeqhvBtxI3vZTg9t1CBPEObUz6qthHxSxSZjL5dIgam/DcZUkBgm2hiNHRx1tcXg3T0jo8DpLlBEjBxpUgM8njPa7OtElJ0gUi7l1vXhV7+v1iWvdDZB06ICMF97mpGTMDend/3Uxn0Ol3xg7fUuaAWQA9uK18Ia2ZxplPhAxdcbVn0tTmf4a/ADYJQFlZoSAFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/椭圆形.png
// module id = vxvQ
// module chunks = 2